<script setup=""></script>

<template>
  <aside class="secondary-sidebar">
    <div class="secondary-sidebar-content flex h-full grow flex-col">
      <!-- Sidebar Panel Body -->
      <div class="flex grow flex-col scrollbar-hide">
        <div>
          <slot />
        </div>
      </div>
    </div>
  </aside>
</template>
